export default {
    common: {
        title: "Editar Imagem",
        cancel: "Cancelar",
        save: "Guardar",
        crop: "Agricultura",
        adjustments: "Ajustamentos",
        filters: "Filtros",
        frames: "Quadros",
        overlays: "Camadas sobrepostas",
        text: "Texto",
        stickers: "Autocolantes",
        brush: "Escova",
        ai: "Criar imagem utilizando IA",
        reset: "Reiniciar",
        comingSoon: 'Brevemente...',
    },
};
